import React from 'react';
import { FocusRing } from 'react-aria';
import { PartnerListStyles as S } from './PartnerList.styles';
const PartnerList = (props) => {
    return (React.createElement(S.Container, { id: props.anchorId, paddingThickness: props.paddingThickness },
        React.createElement(S.ContentArea, null,
            React.createElement(S.Title, null, props.title),
            props.content && React.createElement(S.Content, null, props.content)),
        React.createElement(S.LogoGrid, { "data-theme": props.theme }, props.partners &&
            props.partners.map((item) => (React.createElement("div", { key: item.id },
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.Partner, { href: item.cta ? item.cta.url : undefined, target: item.cta ? item.cta.target : '_self' },
                        React.createElement(S.PartnerLogo, { alt: item.logo?.altText ?? '', loading: "lazy", role: item.logo?.altText ? undefined : 'presentation', src: item.logo.src }),
                        item.cta && (React.createElement(S.PartnerCta, { styleType: "underline", backgroundPlacement: "light", branding: "blue", buttonSize: "small", title: item.cta?.text ?? 'Linkedin Profile' }))))))))));
};
export default PartnerList;
